module.exports = __webpack_public_path__ + "img/enemy_121_002.60e28031.png";